document.addEventListener('DOMContentLoaded', function () {
    const statusCookiePolicy = localStorage.getItem('cookie-policy');
    if(statusCookiePolicy !== 'Y') {
        document.querySelector('.cookie-policy').classList.add('is-open')
    }
    localStorage.setItem('cookie-policy', 'Y');
    document.querySelectorAll('[data-cookie-policy-close]').forEach(el => {
        el.addEventListener('click', () => {
            document.querySelector('.cookie-policy').remove();
        });
    });
});